import { useMyGoogleAccount, useStudioSettings } from '@/data/vault';
import { appEnv } from '@/lib/env';

/** Why the Picker settings in .env won't work, or null. Unset means Picker is simply off. */
export function pickerSettingsProblem(apiKey: string | undefined, appId: string | undefined): string | null {
  if (!apiKey || !appId) return null;
  if (!/^\d+$/.test(appId)) {
    return `VITE_GOOGLE_APP_ID is “${appId}”, but it must be the Google Cloud project number (digits only, on the project's dashboard), not the project ID. Fix it in .env and restart.`;
  }
  if (!apiKey.startsWith('AIza'))
    return 'VITE_GOOGLE_PICKER_API_KEY doesn’t look like a Google API key (they start “AIza”).';
  return null;
}

/** The member's Drive state, all in one: connected, the Hive Uploads folder they can use, and whether Picker is set up. */
export function useDriveStatus() {
  const account = useMyGoogleAccount();
  const settings = useStudioSettings();
  const apiKey = appEnv.ok ? appEnv.env.VITE_GOOGLE_PICKER_API_KEY : undefined;
  const appId = appEnv.ok ? appEnv.env.VITE_GOOGLE_APP_ID : undefined;
  const pickerProblem = pickerSettingsProblem(apiKey, appId);
  return {
    loading: account.isPending || settings.isPending,
    connected: account.data?.connected ?? false,
    /** The Hive Uploads folder this member has picked (drive.file needs each member to pick it once). */
    rootFolderId: account.data?.drive_root_folder_id ?? null,
    studioFolderId: settings.data?.drive_uploads_folder_id ?? null,
    pickerKeys: apiKey && appId && !pickerProblem ? { apiKey, appId } : null,
    pickerProblem,
  };
}
